<template>
  <div id="app">
    <Nav />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'

export default {
	components: {
		Nav,
		Footer
  },
}
</script>

<style lang="scss">
  @import url("https://fonts.googleapis.com/css?family=Roboto");
  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@100;300&display=swap');
  $layout-padding: 450px;
  
  body{
    font-family: "Roboto", "Helvetica Neue",Helvetica,Arial,sans-serif;
  }
  a{
    text-decoration: none !important;
    color: inherit
  }
  ul{
    padding: 0
  }
  ul li{
    list-style: none;
  }
  h2,.h2{
    font-size: 28px !important;
  }
  h3,.h3{
    font-size: 18px !important;
  }
  h4,.h4{
    font-size: 16px !important;
  }
  p, li {
    font-size: 0.9rem;
    letter-spacing: 1.2px;
    line-height: 1.6;
  }
  .btn-sq {
    border-radius: unset;
  }
  .btn-flat {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem
  }
  .btn-primary{
    background-color: $color-main
  }
  .btn-outline-primary{
    color: $color-main;
    background-color: #fff;
    border-color: $color-main ;

    &:hover{
      color: #fff;
      background-color: $color-main;
    }
  }
  main{
    padding-bottom: 0px;
    padding-top: 0px;
    box-shadow: 0px 5px 5px -2px rgba(146,146,146,1);
    background-color: rgba(255,255,255,1);
  }
  .text-main {
    color: $color-main;
  }
  .text-main-aux {
    color: $color-main-aux;
  }
  @media (min-width: 768px) {
    main{
      position: relative;
      z-index: 11;
      margin-bottom: $layout-padding;
    }
    footer{
      position: fixed;
      height: $layout-padding;
    }
  }
  //Owl-Carousel Nav
  .owl-theme .owl-nav {
      margin: 10px;

      button[class*=owl-] {
          color: #999;
          font-size: 14px;
          margin: 5px;
          padding: 4px 7px !important;
          background: #e0f5ff;
          display: inline-block;
          cursor: pointer;
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          border-radius: 3px;

          &:focus{
              outline: unset;
          }
      }
  }
  //Owl-Carousel Dots
  .owl-theme .owl-dots .owl-dot{
      &.active span,
      &:hover span {
        background: $color-main
      }

      &:focus{
          outline: unset;
      }
  }

  // Animate
  .fade-enter-active{
    transition: all .35s linear
  }
  .fade-leave-active {
    transition: all .25s linear
  }
  .fade-enter{
    transform: translateX(-100%)
  }
  .fade-leave-to {
    transform: translateX(100%)
  }
</style>
